import React from 'react';
import { useLang } from '../context/LanguageContext';
import { t } from '../translations';

const WorkExperience = () => {
  const { lang } = useLang();
  const tx = t[lang];

  return (
    <div className="mt-12">
      <h2 className="text-xl font-bold text-gray-900 mb-6">{tx.workTitle}</h2>
      <div className="space-y-8">
        {tx.experiences.map((exp, index) => (
          <div key={index} className="border-l-2 border-gray-200 pl-4">
            <div className="flex justify-between items-start mb-2">
              <div>
                <h3 className="font-semibold text-gray-900">{exp.company}</h3>
                <p className="text-gray-600">{exp.role}</p>
              </div>
              <span className="text-gray-500 text-sm">{exp.period}</span>
            </div>
            <p className="text-gray-600 mb-2">{exp.description}</p>
            <p className="text-gray-500 text-sm">{tx.techLabel}: {exp.tecnologias}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default WorkExperience;
